"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useSearchParams } from "next/navigation";
const SubjectCheckboxSvg = dynamic(() => import("./subject-checkbox-svg"), {
  ssr: false,
});
const SubjectCheckBox = ({
  item,
  appendSearchParams,
  formUrl,
  slug,
  prepopulateFilter,
  isParentCheckBox,
}: any) => {
  const keyName = KeyNames();
  const searchParams = useSearchParams();
  const hasKeywordSearch = searchParams.has(keyName?.keyword);
  const [isChecked, setIsChecked] = useState<boolean>(
    prepopulateFilter?.subject?.split("+")?.includes(item?.subjectTextKey) &&
      !hasKeywordSearch,
  );
  useEffect(() => {
    setIsChecked(
      prepopulateFilter?.subject?.split("+")?.includes(item?.subjectTextKey) &&
        !hasKeywordSearch,
    );
  }, [prepopulateFilter]);
  return (
    <div>
      <Link
        className="hidden"
        id={keyName?.subject + item?.subjectTextKey}
        href={{
          pathname: generatePathName(
            slug,
            keyName?.subject,
            item?.subjectTextKey,
            searchParams,
          ),
          query: formUrl(keyName?.subject, item?.subjectTextKey),
        }}
      >
        {item?.categoryDesc}
      </Link>

      <div className="form_check relative">
        <div className={`flex items-start gap-[8px] form_check`}>
          <div className="checkbox_card">
            <input
              type="checkbox"
              id={`subject-${item?.subjectTextKey}`}
              checked={isChecked}
              onChange={() => {
                setIsChecked(!isChecked);
                appendSearchParams(keyName?.subject, item?.subjectTextKey);
              }}
              className="form-checkbox hidden"
            />
            <label
              htmlFor={`subject-${item?.subjectTextKey}`}
              className="flex justify-center items-center w-[16px] h-[16px] rounded-[3px] border-2 border-grey-600 my-[2px] group-checked:bg-primary-400 cursor-pointer"
            >
              <SubjectCheckboxSvg />
            </label>
          </div>
          <label
            htmlFor={`subject-${item?.subjectTextKey}`}
            className="check-label small font-normal text-grey300 w-[calc(100%_-_28px)]"
          >
            {isParentCheckBox ? "ALL " : ""}
            {item?.categoryDesc}
          </label>
        </div>
      </div>
    </div>
  );
};
export default SubjectCheckBox;
